import {Image} from '@/_application/core/components/ui/image';
import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {getBrandUrl} from '@/_application/core/utils/common';
import {compareBrandByPosition} from '@/_application/modules/brand/helpers/brand-data';
import {AggregationOption, HighlightBrand, HighlightBrands} from '__generated__/__types__';
import Link from 'next/link';
import React, {useMemo} from 'react';

interface ProductCategorySpotlightBrandProps {
    options: AggregationOption[];
    highlightBrands?: HighlightBrands | null;
}

const ProductCategorySpotlightBrand: React.FC<ProductCategorySpotlightBrandProps> = ({options, highlightBrands}) => {
    const brands = useMemo(() => {
        const allBrands = highlightBrands?.items ?? [];

        const filteredBrands = (options
            ?.filter(option => option)
            ?.map(option => {
                return allBrands?.find(brand => brand?.label === option?.value);
            })
            ?.filter(brand => brand) ?? []) as HighlightBrand[];

        return filteredBrands.sort(compareBrandByPosition);
    }, [options, highlightBrands]);

    if (!brands.length) {
        return null;
    }

    return (
        <div className="mb-7 mt-2 border-b pb-3">
            <Swiper loop={true} slidesPerView={4} spaceBetween={10}>
                {brands?.map(brand => {
                    const image = brand?.img;
                    if (!image || !brand?.url) return <></>;
                    const brandUrl = getBrandUrl(brand?.url);

                    return (
                        <SwiperSlide key={brand?.id}>
                            <div className="flex flex-col gap-5">
                                <Link href={brandUrl} className="flex h-[80px] w-[80px] items-center justify-center">
                                    <Image src={image} alt={brand?.label ?? 'Logo'} width={100} height={100} />
                                </Link>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};

export default ProductCategorySpotlightBrand;
